import { useId } from '@reach/auto-id';

// not being use, but leave here for some context if we need to investigate
// the use if generating ids for our own elements. react-aria is already generating
// the ids to facilitate accessibility apis, if we need to generate our own ids for non
// react-aria we will need to investigate how to do it and still be ssr safe. reference
// @reach/auto-id => https://github.com/reach/reach-ui/blob/dev/packages/auto-id/src/reach-auto-id.ts
// have some suggested approach but we will need to fully understand the trade-offs.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function usePropId(propId) {
  var id = useId();
  return propId || id;
}

export { usePropId };
//# sourceMappingURL=use-prop-id.esm.js.map
